import { useMediaQuery, useTheme } from "@mui/material";
import { MOBILE_BREAKPOINT } from "@common/theme";

/**
 * THE app-wide mobile check. Returns `true` when the viewport is narrower than
 * {@link MOBILE_BREAKPOINT} (786px), i.e. a max-width of 785px.
 *
 * This is the single source of truth for "are we on mobile?". New code MUST use
 * this hook instead of inline `useMediaQuery(theme.breakpoints.down(...))` calls
 * or copy-pasted magic numbers (600 / 786 / 900 / 1441). If the breakpoint ever
 * needs to change, change {@link MOBILE_BREAKPOINT} in src/common/theme.ts only.
 */
export function useIsMobile(): boolean {
  const theme = useTheme();
  // breakpoints.down(N) === `(max-width: ${N - 0.05}px)`, i.e. width < N.
  return useMediaQuery(theme.breakpoints.down(MOBILE_BREAKPOINT));
}

/**
 * Convenience inverse of {@link useIsMobile}. Returns `true` when the viewport is
 * at least {@link MOBILE_BREAKPOINT} wide (desktop / tablet-landscape).
 */
export function useIsDesktop(): boolean {
  return !useIsMobile();
}
